module.exports = __webpack_public_path__ + "img/paypal.cb0a8009.svg";